
import { $ } from "../third-party-imports";

export function clearNewsLetterForm(form: any)
{
    $(form).find("#inputfname").val("");
    $(form).find("#inputlname").val("");
    $(form).find("#inputContactEmail").val("");
}
